var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-sortable",
    {
      staticClass: "quick-add",
      attrs: {
        "disable-y": "",
        tag: "ul",
        "target-class": "handle",
        items: _vm.buttons,
      },
    },
    [
      _vm._l(_vm.buttons, function (button, i) {
        return _c("app-quick-add-button", {
          key: button.key,
          attrs: { button: button, "edit-mode": _vm.editModeOpen },
          on: {
            delete: function ($event) {
              return _vm.removeButton(i)
            },
          },
        })
      }),
      _vm.editModeOpen
        ? _c(
            "li",
            { staticClass: "add-button" },
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("add-quick-add-button"),
                      expression: "$ct('add-quick-add-button')",
                    },
                  ],
                  attrs: { round: "" },
                  on: {
                    click: function ($event) {
                      return _vm.addButtonClicked()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.addModalOpen,
            callback: function ($$v) {
              _vm.addModalOpen = $$v
            },
            expression: "addModalOpen",
          },
        },
        [
          _vm.addModalOpen
            ? _c("app-quick-add-button-add-modal", {
                on: {
                  close: function ($event) {
                    _vm.addModalOpen = false
                  },
                  confirm: function ($event) {
                    return _vm.addButton($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }